import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";


@Component({
    selector: 'app-home-notify',
    templateUrl: './home-notify.component.html',
    styleUrls: ['./home-notify.component.css'],
    standalone: false
})
export class HomeNotifyComponent implements OnInit {
  public messages = [];

  constructor(private http: HttpClient) {
    this.http.get("assets/notifications/maintenance.json").subscribe((msg:Array<any>) => {
      let activeMessages: Array<any> = msg.filter(m=>{
        return m.home && m.active
      });

      for (let message of activeMessages) {
        let start = new Date(message.start);
        let end = new Date(message.end);
        let now = new Date();
        let active = true;

        if (message.start) {
          if (start.getTime() > now.getTime()) {
            active = false;
          }
        }

        if(message.end){
          if (end.getTime() < now.getTime()) {
            active = false;
          }
        }

        if (active) {
          this.messages.push(message);
        }
      }
    });
  }

  ngOnInit(): void {
  }

}
